import { useTranslation } from "react-i18next";
import {
  getBarChartOptions,
  getPieChartSessionStatusOptions,
  getRadialBarPagesProgressOptions,
} from "../charts/Options";
import BarChart from "../charts/BarCharts";
import PieChart from "../charts/PieCharts";
import StudentModel from "../../api/models/StudentModel";
import CandidateCourseModel from "../../api/models/CandidateCourseModel";
import { StatisticsSessionsStatus } from "../../api/@types/globalTypes";
import LevelProgressHomeStudent from "../sessions/LevelProgressHomeStudent";
import ReadingCardInfo from "../student-profile/ReadingCardInfo";
import ScheduleSlotModel from "../../api/models/ScheduleSlotModel";
type StudentInfoDetailsProps = {
  student: StudentModel | null | undefined;
  statistics: any;
  sessionStatistics: StatisticsSessionsStatus;
  quranPagesProgress: any;
  sessionsNotes: any;
  quranProgress: any;
  quranProgressSessions: any;
  courses: CandidateCourseModel[];
  scheduleSlots: any;
  skillsStatistics: {
    passed: number;
    total: number;
    unPassed: number;
  };
};
export const StudentProfile = (props: StudentInfoDetailsProps) => {
  const {
    student,
    statistics,
    quranPagesProgress,
    sessionsNotes,
    quranProgressSessions,
    quranProgress,
    courses,
    sessionStatistics,
    scheduleSlots,
    skillsStatistics,
  } = props;

  const LocalBasePath = "page.student.dashboard.room";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  const LabelsSessionStatus = [t(`scheduled`), t(`done`), t(`canceled`)];
  const LabelsSkills = [t(`passed`), t(`unpassed`)];

  const SessionStatusPieData = [
    sessionStatistics?.scheduled || 0,
    sessionStatistics?.completed || 0,
    sessionStatistics?.canceled || 0,
  ];
  const PagesProgressPieData = [
    quranPagesProgress?.remaining || 0,
    quranPagesProgress?.finished || 0,
  ];

  const LabelsPagesProgress = [t(`remaining`), t(`left`)];

  return (
    <div className="flex flex-col  w-full col-span-2 gap-5  bg-gray-50  mb-2  min-h-screen p-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="w-full col-span-3 overflow-hidden">
          <div className="flex flex-col gap-2.5">
            <h1 className="text-xs font-semibold text-gray-900">
              {" "}
              {t(`readerInfo`)}
            </h1>
            <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-3 ">
              <ReadingCardInfo
                label={t("telawah")}
                text={student?.telawah?.name ?? ""}
              />
              <ReadingCardInfo
                label={t("startingReading")}
                text={student?.tutor?.fullNameWithoutMiddle ?? ""}
              />
              <ReadingCardInfo
                label={t("sponsorship")}
                text={student?.sponsorship?.sponsor?.name ?? ""}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white  rounded-lg  shadow-sm  p-4 ">
        <div className="w-full col-span-3 overflow-hidden ">
          <div className="flex flex-col ">
            <h1 className="text-sm font-normal text-gray-400">
              {" "}
              {t(`weeklySchedule`)}
            </h1>
            <div className="flex flex-col  md:flex-row w-full   gap-5  ">
              {Object.keys(scheduleSlots)?.length > 0 &&
                Object.keys(scheduleSlots).map((item) => {
                  return (
                    <div className="w-full   flex gap-8 flex-col">
                      <div className="w-full flex flex-col  justify-center gap-[2px]">
                        <h4 className="text-sm text-gray-600"> {t(item)}</h4>
                        <div className="flex flex-col gap-1">
                          {scheduleSlots[item]?.length > 0 &&
                            scheduleSlots[item].map(
                              (slot: ScheduleSlotModel) => (
                                <p className="text-sm font-medium text-brandblue-600">
                                  {slot.startTime.format("HH:mm")}
                                  {" - "}
                                  {slot.endTime.format("HH:mm")}
                                </p>
                              )
                            )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex mt-1 flex-col  gap-4">
        <div className="w-full flex justify-between items-center">
          <h1 className="text-xs leading-5 font-semibold text-gray-900">
            {t(`learnDashProgress`)}
          </h1>
        </div>
        <div className="w-full flex  bg-white rounded-2xl shadow-sm px-6 py-4">
          <div className="w-full">
            <div className="w-full flex flex-col gap-4 ">
              <LevelProgressHomeStudent listOfLevels={courses} />
            </div>
          </div>{" "}
        </div>
      </div>
      <div className="w-full flex  items-center">
        <h1 className="text-xs font-semibold text-gray-900">
          {t(`sessionsStatistics`)}
        </h1>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="w-full col-span-3 overflow-hidden bg-white rounded-lg shadow">
          <div className="px-4 py-5 sm:p-6">
            <h1 className="text-sm leading-4 font-normal text-gray-400">
              {t(`quraanProgress`)}
            </h1>
            <div>
              <BarChart
                options={getBarChartOptions(
                  [
                    {
                      name: t("quranProgress"),
                      data: quranProgress ?? [],
                    },
                  ],
                  quranProgressSessions ?? []
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex gap-6 flex-col lg:flex-row mb-5">
        <div className="relative w-full overflow-hidden bg-white rounded-lg shadow">
          {sessionsNotes?.passedNotes == 0 &&
            sessionsNotes?.unpassedNotes == 0 && (
              <div className="absolute top-0 left-0  w-full h-full z-50">
                <div className="h-full w-full flex justify-center items-center">
                  <p className="text-sm"> {t("noData")}</p>
                </div>
              </div>
            )}
          <div className="px-4 py-5 sm:p-6">
            <h1 className="text-sm leading-4 font-normal text-gray-400">
              {t(`observedNotesForEachSession`)}
            </h1>
            <div>
              <PieChart
                options={getRadialBarPagesProgressOptions(
                  [t(`passed`) ?? 0, t(`unpassed`) ?? 0],
                  [sessionsNotes?.passedNotes, sessionsNotes?.unpassedNotes]
                )}
              />
            </div>
          </div>
        </div>

        <div className="w-full overflow-hidden bg-white rounded-lg shadow">
          <div className="relative px-4 py-5 sm:p-6">
            {PagesProgressPieData[0] == 0 && PagesProgressPieData[1] == 0 && (
              <div className="absolute top-0 left-0  w-full h-full z-50">
                <div className="h-full w-full flex justify-center items-center">
                  <p className="text-sm"> {t("noData")}</p>
                </div>
              </div>
            )}
            <h1 className="text-sm leading-4 font-normal text-gray-400">
              {t(`inprogressReading`)}
            </h1>
            <div>
              <PieChart
                options={getRadialBarPagesProgressOptions(
                  LabelsPagesProgress,
                  PagesProgressPieData
                )}
              />
            </div>
          </div>
        </div>
        <div className="w-full my-4  overflow-hidden bg-white rounded-lg shadow md:my-0">
          <div className="relative px-4 py-5 sm:p-6">
            {SessionStatusPieData[0] == 0 &&
              SessionStatusPieData[1] == 0 &&
              SessionStatusPieData[2] == 0 && (
                <div className="absolute top-0 left-0  w-full h-full z-50">
                  <div className="h-full w-full flex justify-center items-center">
                    <p className="text-sm"> {t("noData")}</p>
                  </div>
                </div>
              )}
            <h1 className="text-sm leading-4 font-normal text-gray-400">
              {t(`sessionStatus`)}
            </h1>
            <div>
              <PieChart
                options={getPieChartSessionStatusOptions(
                  LabelsSessionStatus,
                  SessionStatusPieData
                )}
              />
            </div>
          </div>
        </div>

        <div className="w-full overflow-hidden bg-white rounded-lg shadow md:col-span-2">
          <div className="relative px-4 py-5  sm:p-6">
            {skillsStatistics?.passed == 0 && skillsStatistics?.unPassed == 0 && (
              <div className="absolute top-0 left-0  w-full h-full z-50">
                <div className="h-full w-full flex justify-center items-center">
                  <p className="text-sm"> {t("noData")}</p>
                </div>
              </div>
            )}
            <h1 className="text-sm leading-4 font-normal text-gray-400">
              {t(`skillsStatus`)}
            </h1>
            <div>
              <PieChart
                options={getRadialBarPagesProgressOptions(LabelsSkills, [
                  skillsStatistics?.passed,
                  skillsStatistics?.unPassed,
                ])}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
